import React from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import {
  FaMoneyBillWave,
  FaClock,
  FaFileAlt,
  FaChartLine,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import "../assets/styles/index.css";

const UserDashboardScreen = () => {
  const quickActions = [
    {
      id: 1,
      title: "Mark Attendance",
      description: "Check in/out for today",
      icon: <FaClock />,
      color: "#1e88e5",
      link: "/attendance",
    },
    {
      id: 2,
      title: "Apply Leave",
      description: "Submit leave application",
      icon: <FaFileAlt />,
      color: "#43a047",
      link: "/leave-application",
    },
    {
      id: 3,
      title: "Salary Details",
      description: "View salary slip & details",
      icon: <FaMoneyBillWave />,
      color: "#fb8c00",
      link: "/staff-salary-sheet",
    },
    {
      id: 4,
      title: "Reports",
      description: "View attendance reports",
      icon: <FaChartLine />,
      color: "#8e24aa",
      link: "/yearly",
    },
  ];

  return (
    <div className="modern-dashboard">
      <Container fluid className="px-4 py-3">
        {/* Page Header */}
        <div className="dashboard-header mb-4">
          <h2 className="dashboard-title">Dashboard</h2>
        </div>

        {/* Quick Actions */}
        <Row>
          <Col xs={12}>
            <h4 className="section-title mb-3">Quick Actions</h4>
          </Col>
          {quickActions.map((action) => (
            <Col key={action.id} xs={12} sm={6} lg={3} className="mb-3">
              <Link to={action.link} className="text-decoration-none">
                <Card className="action-card h-100 border-0 shadow-sm">
                  <Card.Body className="p-4 text-center">
                    <div className="action-icon-container mb-3" style={{ backgroundColor: `${action.color}15` }}>
                      <div className="action-icon" style={{ color: action.color }}>
                        {action.icon}
                      </div>
                    </div>
                    <h6 className="action-title">{action.title}</h6>
                    <p className="action-description text-muted mb-0">{action.description}</p>
                  </Card.Body>
                </Card>
              </Link>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default UserDashboardScreen; 